import * as React from 'react';
import Svg, {
  SvgProps,
  Path,
  Defs,
  LinearGradient,
  Stop,
} from 'react-native-svg';

const SparklesIcon = (props: SvgProps) => (
  <Svg
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <Path
      stroke="url(#b)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.178 13.253 7.5 15.625l-.678-2.372a3.75 3.75 0 0 0-2.575-2.575L1.875 10l2.372-.678a3.75 3.75 0 0 0 2.575-2.575L7.5 4.375l.678 2.372a3.75 3.75 0 0 0 2.575 2.575l2.372.678-2.372.678a3.75 3.75 0 0 0-2.575 2.575Z"
    />
    <Path
      stroke="url(#b)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.216 7.262 15 8.125l-.216-.863a2.812 2.812 0 0 0-2.046-2.046L11.875 5l.863-.216a2.812 2.812 0 0 0 2.046-2.046L15 1.875l.216.863a2.812 2.812 0 0 0 2.046 2.046l.863.216-.863.216a2.812 2.812 0 0 0-2.046 2.046Z"
    />
    <Path
      stroke="url(#c)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m14.079 17.14-.329.985-.329-.986c-.186-.56-.625-.999-1.185-1.185l-.986-.329.986-.329c.56-.186.999-.625 1.185-1.185l.329-.986.329.986c.186.56.625.999 1.185 1.185l.986.329-.986.329c-.56.186-.999.625-1.185 1.185Z"
    />
    <Defs>
      <LinearGradient
        id="a"
        x1={21.68}
        x2={-7.038}
        y1={-1.897}
        y2={1.597}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#548FC8" />
        <Stop offset={1} stopColor="#9C007A" />
      </LinearGradient>
      <LinearGradient
        id="b"
        x1={21.68}
        x2={-7.038}
        y1={-1.897}
        y2={1.597}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#548FC8" />
        <Stop offset={1} stopColor="#9C007A" />
      </LinearGradient>
      <LinearGradient
        id="c"
        x1={21.68}
        x2={-7.038}
        y1={-1.897}
        y2={1.597}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#548FC8" />
        <Stop offset={1} stopColor="#9C007A" />
      </LinearGradient>
    </Defs>
  </Svg>
);
export default SparklesIcon;
